import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class RemotesService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Upsert remote
     * Upsert remote.
     * If remote with the same `mountPath` and `type` already exists the remote object is returned.
     * If the `type` doesn't match the existing remote, a 409 error is returned.
     * Otherwise, a new remote is created.
     * @returns Remote Remote created.
     * @throws ApiError
     */
    upsertRemote({ orgId, projectId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/remotes', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * List remotes
     * List remotes.
     * @returns any OK.
     * @throws ApiError
     */
    listRemotes({ orgId, projectId, after, before, limit = 10, filter, sort = '-id', search, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/remotes', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'limit': limit,
                'filter': filter,
                'sort': sort,
                'search': search,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get remote
     * Get remotes.
     * @returns Remote OK.
     * @throws ApiError
     */
    getRemote({ orgId, projectId, remoteId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/remotes/{remoteId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'remoteId': remoteId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * @deprecated
     * Update remote
     * Update remote by id.
     * @returns Remote Remote Content updated.
     * @throws ApiError
     */
    updateRemoteById({ orgId, projectId, remoteId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PATCH', url: '/orgs/{orgId}/projects/{projectId}/remotes/{remoteId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'remoteId': remoteId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Delete remote
     * Delete remote.
     * @returns Remote OK.
     * @throws ApiError
     */
    deleteRemote({ orgId, projectId, remoteId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'DELETE', url: '/orgs/{orgId}/projects/{projectId}/remotes/{remoteId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'remoteId': remoteId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get remote content url
     * Get remote content url for cloning repo or downloading file.
     * @returns any Remote Content URL.
     * @throws ApiError
     */
    getRemoteUrl({ orgId, projectId, remoteId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/remotes/{remoteId}/url', path: {
                'orgId': orgId,
                'projectId': projectId,
                'remoteId': remoteId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get Git remote content repository
     * Get repository details of the remote content with type GIT.
     * @returns any Git Remote Content repository.
     * @throws ApiError
     */
    getGitRemoteRepository({ orgId, projectId, remoteId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/remotes/{remoteId}/repository', path: {
                'orgId': orgId,
                'projectId': projectId,
                'remoteId': remoteId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get Git remote content branches
     * Get branches of the remote content with type GIT.
     * @returns RemoteBranch Git Remote Content branches.
     * @throws ApiError
     */
    getGitRemoteBranches({ orgId, projectId, remoteId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/remotes/{remoteId}/branches', path: {
                'orgId': orgId,
                'projectId': projectId,
                'remoteId': remoteId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get Git remote content commit details
     * Get commit details by SHA1 of the remote content with type GIT.
     * @returns CommitDetailsSchema Git Remote Content commit details.
     * @throws ApiError
     */
    getGitRemoteCommitDetails({ orgId, projectId, remoteId, commitSha, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/remotes/{remoteId}/commits/{commitSha}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'remoteId': remoteId,
                'commitSha': commitSha,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Sync remote content
     * Sync connected remote content.
     * @returns any Remote content update created.
     * @throws ApiError
     */
    syncRemote({ orgId, projectId, remoteId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/remotes/{remoteId}/sync', path: {
                'orgId': orgId,
                'projectId': projectId,
                'remoteId': remoteId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get list of remote content commits
     * @returns RemoteCommitList OK.
     * @throws ApiError
     */
    listRemoteCommits({ orgId, projectId, after, before, sort = '-id', filter, limit = 10, search, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/remote-commits', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'sort': sort,
                'filter': filter,
                'limit': limit,
                'search': search,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get single remote content commit
     * @returns RemoteCommit OK.
     * @throws ApiError
     */
    getRemoteCommit({ orgId, projectId, commitId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/remote-commits/{commitId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'commitId': commitId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update URL remote content update
     * Update URL remote content update.
     * @returns UrlRemoteUpdate Successfully updated.
     * @throws ApiError
     */
    patchUrlRemoteUpdate({ orgId, projectId, urlRemoteUpdateId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PATCH', url: '/orgs/{orgId}/projects/{projectId}/url-remote-updates/{urlRemoteUpdateId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'urlRemoteUpdateId': urlRemoteUpdateId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * List GIT remote updates
     * List GIT remote updates.
     * @returns GitRemoteUpdateList OK.
     * @throws ApiError
     */
    listGitRemoteUpdates({ orgId, projectId, after, before, sort = '-id', filter, limit = 10, search, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/git-remote-updates', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'sort': sort,
                'filter': filter,
                'limit': limit,
                'search': search,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update GIT remote content update
     * Update GIT remote content update.
     * @returns GitRemoteUpdate Successfully updated.
     * @throws ApiError
     */
    patchGitRemoteUpdate({ orgId, projectId, gitRemoteUpdateId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PATCH', url: '/orgs/{orgId}/projects/{projectId}/git-remote-updates/{gitRemoteUpdateId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'gitRemoteUpdateId': gitRemoteUpdateId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=RemotesService.js.map